/**
 * 配置编译环境与线上环境之间的切换
 *
 *path: 域名地址
 *
 */
// let path = 'http://127.0.0.1:86'
// let path = 'https://m.ddayi.com'
let path = 'http://api.hmsfans.com'
//本地开发需要代理的加上/api
if (process.env.NODE_ENV === 'development') path = '/apiv2'
export { path }



// WEBPACK FOOTER //
// ./src/config/env.js